import React from 'react'
import { Link } from 'react-router-dom'
import footer_1 from '../../assets/images/footer-logo.svg';
import footer_2 from '../../assets/images/svg/footer-two/footer-two-mail.svg';
import footer_3 from '../../assets/images/svg/footer-two/footer-two-address.svg';
import footer_4 from '../../assets/images/footer-icon/footer-one-1.svg';
import footer_5 from '../../assets/images/footer-icon/footer-one-2.svg';
import footer_6 from '../../assets/images/footer-icon/footer-one-3.svg';
import footer_7 from '../../assets/images/footer-icon/footer-one-4.svg';
import footer_8 from '../../assets/images/footer-icon/footer-one-5.svg';
import footer_9 from '../../assets/images/footer-icon/footer-one-6.svg';
import footer_10 from '../../assets/images/footer-icon/footer-one-7.svg';
import footer_11 from '../../assets/images/footer-icon/footer-one-8.svg';
import footer_12 from '../../assets/images/footer-icon/footer-one-9.svg';
import footer_13 from '../../assets/images/footer-icon/footer-one-10.svg';
import footer_14 from '../../assets/images/svg/header/Insta.svg';
import footer_15 from '../../assets/images/svg/header/Fb.svg';
import footer_16 from '../../assets/images/svg/header/Twiter.svg';
import footer_17 from '../../assets/images/svg/header/Pintrest.svg';

const Footer4 = () => {
    return (
        <>
            <footer className="footer-section-four">
                <div className="container-fluid">
                    <div className="row gutter-y-30">
                        <div className="col-12">
                            <div
                                className="footer-four-logo animate zoomIn wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <Link to="/">
                                    <img src={footer_1} alt="logo" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6">
                            <div
                                className="footer-about-four animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <h4>About Uniqo</h4>
                                <p>
                                    Over the past three years, marketers have faced an arduous journey.
                                </p>
                                <ul className="footer-location-four">
                                    <li>
                                        <span>
                                            <img
                                                src={footer_2}
                                                alt="icon"
                                            />
                                        </span>
                                        <Link to="mailto:needhelp@company.com">needhelp@company.com</Link>
                                    </li>
                                    <li>
                                        <span>
                                            <img
                                                src={footer_3}
                                                alt="icon"
                                            />
                                        </span>
                                        <p>135 klf, Hotland, USA</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-md-6">
                            <div
                                className="footer-newslatter-four animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <h4>Subscribe To Newsletter</h4>
                                <p>
                                    At uniquo, we are a renowned global consulting firm committed to
                                    collaborating with business and societal leaders in challenges and
                                    opportunities.
                                </p>
                                <div className="form-newslatter-four">
                                    <form action="#">
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            placeholder="Enter Your Email"
                                            required=""
                                        />
                                        <button type="submit" className="btn btn-dark btn-theme">
                                            Subscribe <span>+</span>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="footer-widget-one animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <h4>Services</h4>
                                <ul className="footer-menu-one">
                                    <li>
                                        <img
                                            src={footer_4}
                                            alt="icon"
                                        />
                                        <Link to="/ServiceDetails">Financial Analysis</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_5}
                                            alt="icon"
                                        />
                                        <Link to="/ServiceDetails">Work organization</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_6}
                                            alt="icon"
                                        />
                                        <Link to="/ServiceDetails">Digital Marketing</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_7}
                                            alt="icon"
                                        />
                                        <Link to="/ServiceDetails">Innovation space</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_8}
                                            alt="icon"
                                        />
                                        <Link to="/ServiceDetails">Risk Advisory</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                            <div
                                className="footer-widget-one animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="800ms"
                            >
                                <h4>Pages</h4>
                                <ul className="footer-menu-one">
                                    <li>
                                        <img
                                            src={footer_9}
                                            alt="icon"
                                        />
                                        <Link to="/Aboutus">About</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_10}
                                            alt="icon"
                                        />
                                        <Link to="/Careers">Career</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_11}
                                            alt="icon"
                                        />
                                        <Link to="/Aboutus">Applications</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_12}
                                            alt="icon"
                                        />
                                        <Link to="/Contact">Contact Us</Link>
                                    </li>
                                    <li>
                                        <img
                                            src={footer_13}
                                            alt="icon"
                                        />
                                        <Link to="/Portfolio">Case Studies</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="footer-lower-two">
                                <p className="lead">
                                    © Copyright@&nbsp;Uniqo&nbsp;All rights reserved
                                </p>
                                <ul>
                                    <li>
                                        <Link to="https://www.instagram.com/">
                                            <img src={footer_14} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.facebook.com/">
                                            <img src={footer_15} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/">
                                            <img src={footer_16} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.pinterest.com/">
                                            <img src={footer_17} alt="icon" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer4